import type * as React from 'react';

function SvgBetslip(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 16 20" width="1em" {...props}>
      <path
        d="M14.197 0C15.193 0 16 .823 16 1.838v14.999a.46.46 0 01-.248.413l-.18.046a.45.45 0 01-.316-.115l-1.735-1.63-.225.206v3.767a.461.461 0 01-.27.414l-.18.045a.441.441 0 01-.316-.114l-1.713-1.631-1.78 1.63a.444.444 0 01-.609 0l-1.78-1.63-1.78 1.63a.444.444 0 01-.609 0l-1.758-1.63-1.735 1.63a.442.442 0 01-.487.097.459.459 0 01-.279-.418V4.548C0 3.533.807 2.71 1.803 2.71h.901v-.872C2.704.823 3.511 0 4.507 0zm-2.704 3.606h-9.69a.911.911 0 00-.902.919V18.49l1.285-1.194a.445.445 0 01.608 0l1.78 1.63 1.78-1.63a.448.448 0 01.61 0l1.78 1.63 1.78-1.63a.445.445 0 01.608 0l1.262 1.194V4.525a.91.91 0 00-.901-.919zM14.175.92h-9.69a.91.91 0 00-.902.919v.85h7.887c.996 0 1.803.822 1.803 1.837v9.992a.444.444 0 01.541.069L15.1 15.78l-.023-13.942a.911.911 0 00-.901-.92zM9.583 13c.23 0 .417.224.417.5s-.187.5-.417.5H4.417c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zm0-3c.23 0 .417.224.417.5s-.187.5-.417.5H4.417c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zm-2.06-3c.264 0 .477.224.477.5s-.213.5-.476.5H4.476C4.213 8 4 7.776 4 7.5s.213-.5.476-.5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgBetslip;
